module.exports = __webpack_public_path__ + "img/clound.fe9022f3.jpg";